import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon.types';

export const NewFolderIcon: FC<IconProps> = ({ className, iconColor = '#ffffff', ...props }) => (
  <svg
    className={twMerge('shrink-0', className)}
    fill="none"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 15.834H4.16667C3.72464 15.834 3.30072 15.6584 2.98816 15.3458C2.67559 15.0333 2.5 14.6093 2.5 14.1673V5.00065C2.5 4.55862 2.67559 4.1347 2.98816 3.82214C3.30072 3.50958 3.72464 3.33398 4.16667 3.33398H7.5L10 5.83398H15.8333C16.2754 5.83398 16.6993 6.00958 17.0118 6.32214C17.3244 6.6347 17.5 7.05862 17.5 7.50065V10.4173"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
    />
    <path
      d="M13.3333 15.834H18.3333"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
    />
    <path
      d="M15.8333 13.334V18.334"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
    />
  </svg>
);
